import { GET_LANGUAGES, GET_LABELS, GET_LABELS_Name } from "./actions";

const initialState = {
  languages: [],

  labels: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  loading: true,
};

export default function languageReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_LANGUAGES:
      return {
        ...state,
        languages: payload,
        loading: false,
      };
    case GET_LABELS:
      return {
        ...state,
        labels: payload,
        loading: false,
      };
    case GET_LABELS_Name:
      return { ...state, adminLabelsName: payload };
    default:
      return state;
  }
}
